import _ from 'underscore';

export const TYPE = {
  ALL: 'ALL',
  BULK: 'BULK',
  REGISTRY: 'REGISTRY',
  ENTRIES: 'ENTRIES',
  SEQUENCE: 'SEQUENCE',
  OLIGO: 'OLIGO',
  WORKSHEET: 'WORKSHEET',
};
export const FORMAT = {
  ALL_ZIP: 'ALL_ZIP',
  ALL_ZIP_HTML: 'ALL_ZIP_HTML',
  BULK_ZIP_PDF: 'BULK_ZIP_PDF',
  BULK_ZIP_HTML: 'BULK_ZIP_HTML',
  REGISTRY_CSV: 'REGISTRY_CSV',
  ENTRIES_GROUP_BY_DATE: 'ENTRIES_GROUP_BY_DATE',
  ENTRIES_GROUP_BY_ENTRY: 'ENTRIES_GROUP_BY_ENTRY',
  ENTRIES_GROUP_BY_DATE_HTML: 'ENTRIES_GROUP_BY_DATE_HTML',
  ENTRIES_GROUP_BY_ENTRY_HTML: 'ENTRIES_GROUP_BY_ENTRY_HTML',
  SEQUENCE_ZIP: 'SEQUENCE_ZIP',
  SEQUENCE_MULTIPART_GB: 'SEQUENCE_MULTIPART_GB',
  OLIGO_CSV: 'OLIGO_CSV',
  WORKSHEET_PDF: 'WORKSHEET_PDF',
};
export const FILE_FORMAT = {
  CSV: 'CSV',
  HTML: 'HTML',
  MULTIPART_GB: 'MULTIPART',
  PDF: 'PDF',
  ZIP: 'ZIP',
};
export const GROUPING_FORMAT = {
  BY_DATE: 'BY_DATE',
  BY_ENTRY: 'BY_ENTRY',
};
export const STATUS = {
  /* Keep in sync with benchling/models/mixins/has_status.py:HasStatus.Status */
  PENDING: 'pending',
  RUNNING: 'running',
  FAILED: 'failed',
  SUCCEEDED: 'succeeded',
};

export const GBPreferences = {
  EXPORT_ANNOTATION_COLORS: 'GB_EXPORT_ANNOTATION_COLORS',
  CONVERT_NON_STANDARD_ANNOTATIONS: 'export.restrictFeatType',
};

export const TYPE_TO_FORMATS: {[type: string]: Array<string>} = _.object([
  [TYPE.ALL, [FORMAT.ALL_ZIP, FORMAT.ALL_ZIP_HTML]],
  [TYPE.REGISTRY, [FORMAT.REGISTRY_CSV]],
  [
    TYPE.ENTRIES,
    [
      FORMAT.ENTRIES_GROUP_BY_DATE,
      FORMAT.ENTRIES_GROUP_BY_ENTRY,
      FORMAT.ENTRIES_GROUP_BY_DATE_HTML,
      FORMAT.ENTRIES_GROUP_BY_ENTRY_HTML,
    ],
  ],
  [TYPE.SEQUENCE, [FORMAT.SEQUENCE_ZIP, FORMAT.SEQUENCE_MULTIPART_GB]],
  [TYPE.OLIGO, [FORMAT.OLIGO_CSV]],
  [TYPE.WORKSHEET, [FORMAT.WORKSHEET_PDF]],
]);
